import { addRule } from '@chrisjwarnes/form-validator/src'

function addWebTrackingToForms () {
  addRule('valWebTracking', function (field) {
    return {
      type: 'string',
      asyncValidator: (rule, value) => {
        return new Promise((resolve, reject) => {
          if (field.value.length === 0) {
            const trackingId = new Date().toISOString().replace(/-/g, '').split('.')[0].replace('T', '').replace(/:/g, '')

            value = trackingId
            field.value = value
          }
          resolve()
        })
      }
    }
  })
}

export {
  addWebTrackingToForms
}
